import React from 'react'
import { Edit, useForm } from '@refinedev/antd'
import { Form, Select, Input } from 'antd'
import type { Tables } from '@muaa/shared'

type Donation = Tables<'donations'>

// The money fields (amount/fund/frequency) are webhook-owned — surfaced here
// read-only. Correcting a stuck `status` is the point of this editor.
const STATUS_OPTIONS = [
  { value: 'pending', label: 'Pending' },
  { value: 'succeeded', label: 'Succeeded' },
  { value: 'failed', label: 'Failed' },
  { value: 'canceled', label: 'Canceled' },
  { value: 'mock_complete', label: 'Mock Complete' },
]

export function DonationEdit() {
  const { formProps, saveButtonProps, query } = useForm<Donation>()
  const record = query?.data?.data

  const formatMoney = (value: number | null | undefined) =>
    value != null
      ? `$${Number(value).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`
      : '—'

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        {/* Display-only money fields (webhook-owned). */}
        <Form.Item label="Amount">
          <Input value={formatMoney(record?.amount)} disabled />
        </Form.Item>

        <Form.Item label="Fund">
          <Input value={record?.fund ?? '—'} disabled />
        </Form.Item>

        <Form.Item label="Frequency">
          <Input value={record?.frequency ?? '—'} disabled />
        </Form.Item>

        <Form.Item label="Stripe Payment Intent">
          <Input value={record?.stripe_payment_intent_id ?? '—'} disabled />
        </Form.Item>

        {/* The editable field: correct a stuck reconciliation status. */}
        <Form.Item label="Status" name="status" rules={[{ required: true }]}>
          <Select options={STATUS_OPTIONS} placeholder="Select status" />
        </Form.Item>
      </Form>
    </Edit>
  )
}
